<template>
  <div class="row">
    <div class="col">
      <h2 class="titre">Consultation véhicule</h2>
    </div>
  </div>
    <div v-if="isDataLoading == true" class="row">
        <div class="col">
          <vue-loaders  name="ball-beat" ></vue-loaders>
       </div>
  </div>
  <div v-else class="row">
    <div class="col">
      <div class="row">
        <div class="col lbl">
          <label>Immatriculation :</label>
        </div>
        <div class="col txt">
          <p v-if="!immatriculation"> ... </p>
          <p v-else> {{ immatriculation }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl">
          <label>Marque :</label>
        </div>
        <div class="col txt">
          <p v-if="!marqueAfficher"> ... </p>
          <p v-else> {{ marqueAfficher }} </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col lbl">
          <label>Modèle :</label>
        </div>
        <div class="col txt">
          <p v-if="!modeleAfficher"> ... </p>
          <p v-else> {{ modeleAfficher }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl">
          <label>Année :</label>
        </div>
        <div class="col txt">
          <p v-if="!annee"> ... </p>
          <p v-else> {{ annee }} </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformationBasic',
  props: ['isDataLoading','immatriculation', 'marqueAfficher', 'modeleAfficher', 'annee'],
}
</script>